import { useState } from 'react';
import useCheckedCollection from './useCheckedCollection';

function useIntegratedCheckedCollection<T extends object>(
  items: T[],
  selectKey: keyof T,
  initialCheckedItems: T[] = []
) {
  const [checkedItems, setCheckedItems] = useState(() => initialCheckedItems);
  const { onCheck } = useCheckedCollection(items, checkedItems, selectKey, setCheckedItems);
  return { checkedItems, onCheck };
}

export default useIntegratedCheckedCollection;
